<template>
  <div>
    <CoreDateTimeRangeComponent
      :dateStart="dateStart"
      :dateEnd="!ongoing && dateEnd ? dateEnd : undefined"
      :format="format"
    />{{ ongoing ? ` – ${$t('shared.ongoing')?.toLowerCase()}` : '' }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  dateStart: {
    type: String,
    required: true
  },
  dateEnd: {
    type: String,
    required: false
  },
  ongoing: {
    type: Boolean,
    required: false
  },
  hideMonths: {
    type: Boolean,
    default: false
  },
  hideDays: {
    type: Boolean,
    default: false
  }
})

const format = computed(() => {
  if (props.hideMonths && props.hideDays) {
    return 'YYYY'
  } else if (props.hideMonths) {
    return 'D MMMM YYYY'
  } else if (props.hideDays) {
    return 'MMMM YYYY'
  }
  return 'D MMMM YYYY'
})
import { computed } from 'vue'
</script>
